export const mobileBreakpoint = 767;
export const tabletBreakpoint = 1210;

export const theme = {
  breakpoints: [`${mobileBreakpoint}px`, `${tabletBreakpoint}px`],
};
